import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import '../styles/EmailGenerator.css';

var selectedSkills = []
var currentType = 1
var currentPosition = 1

function clickHandler(skill, data, setData) {
    if (selectedSkills.includes(skill)) {
        selectedSkills.splice(selectedSkills.indexOf(skill), 1)
    } else {
        selectedSkills.push(skill)
    }

    updateQuery(data, setData)
    setData(Object.assign({}, data))
}

function keyPressHandler(event, data, setData) {
    if (event.code != "Enter") {
        return
    }

    const skillBox = document.getElementsByName("Add Skill")[0]
    selectedSkills.push(skillBox.value)
    skillBox.value = ""
    updateQuery(data, setData)
    setData(Object.assign({}, data))
}

function getEmail(requestManager, data, setData) {
    const loadingBox = document.getElementById("loadingBox")
    loadingBox.style.display = ""

    const prompt = document.getElementById("prompt").value
    const query = document.getElementById("query").value

    requestManager.request("emailGenerator", "POST", { contactID: data.contactID, companyID: data.companyID, userID: data.userID, selectedSkills: selectedSkills, emailType: currentType, emailPosition: currentPosition, prompt: prompt, query: query }).then(res => res.json()).then((response) => {
        data.email = response["email"]
        data.subject = response["subject"]
        data.recepient = response["recepient"]
        data.signature = response["signature"]

        const emailBox = document.getElementById("emailBox")
        emailBox.style.display = ""

        const subjectBox = document.getElementById("subjectBox")
        subjectBox.style.display = ""

        const emailDiv = document.getElementById("emailDiv")
        emailDiv.style.display = ""

        emailBox.value = data.email //.replaceAll("\n", "<br>")
        subjectBox.value = data.subject

        loadingBox.style.display = "none"

        setData(Object.assign({}, data))
    })
}

function sendEmail(requestManager, data, setData) {
    if (window.confirm("If you have given Jack your login information this will ACTUALLY send the email on this page to " + data.recepient + " from your account. \n\nAre you sure you want to do this?")) {
        const sendingBox = document.getElementById("sendingBox")
        const sentBox = document.getElementById("sentBox")
        sendingBox.style.display = ""

        const emailBox = document.getElementById("emailBox")
        const subjectBox = document.getElementById("subjectBox")

        requestManager.request("emailGenerator", "POST", { contactID: data.contactID, companyID: data.companyID, userID: data.userID, selectedSkills: selectedSkills, emailType: currentType, emailPosition: currentPosition, emailToSend: emailBox.value, subjectToSend: subjectBox.value }).then(res => res.json()).then((response) => {
            sendingBox.style.display = "none"
            sentBox.style.display = ""

            setTimeout(() => sentBox.style.display = "none", 6000)
            // setData(Object.assign({}, data))
        })
    }
}

function updateQuery(data, setData) {
    data.query = "Could you draft a short, professional email for a salesperson at an IT Staff Augmentation firm called 'Resource 1' for a recipient  named '" + data.contactName.replaceAll("  ", " ").trim() + "' at a company called '" + data.companyName + "'? "

    if (currentType == 1) {
        data.query += "The email should suggest expertise in areas similar to some of the following: " + selectedSkills.toString().replaceAll(",", ", ") + ". "
    } else if (currentType == 2) {
        const prompt = document.getElementById("prompt").value
        data.query += "This email is in response to the following email from them: '''" + prompt + "'''. "
    } else if (currentType == 3) {
    } else if (currentType == 4) {
        data.query += "This email should conclude by assertively asking them to get on a call. "
    }

    var currentPositionStr = ""
    if (currentPosition == 1) {
        currentPositionStr = "1st"
    } else if (currentPosition == 2) {
        currentPositionStr = "2nd"
    } else {
        currentPositionStr = "3rd"
    }
    data.query += "This is our " + currentPositionStr + " email to them. Use professional, but still casual/simple language and keep it to 9 sentences or less. Make sure no individual sentence is overly wordy. Use basic human-like vocabulary."
    // data.query += " Do not ask for their time, but rather ask if the service is top of mind and you would be happy to send further info if there's interest."

    setData(Object.assign({}, data))
}

function updatePosition(pos, data, setData) {
    currentPosition = pos
    updateQuery(data, setData)
}

function updateType(type, data, setData) {
    currentType = type

    var skillBox = document.getElementById("manualSkillBox")
    var table = document.getElementById("small-table-wrapper")
    var skillIndicator = document.getElementById("skillIndicator")
    var promptBox = document.getElementById("promptBox")

    skillBox.style.display = "none"
    table.style.display = "none"
    skillIndicator.style.display = "none"
    promptBox.style.display = "none"

    if (type == 1) {
        skillBox.style.display = ""
        table.style.display = ""
        skillIndicator.style.display = ""
    } else if (type == 2) {
        promptBox.style.display = ""
    } else if (type == 3) {

    }

    updateQuery(data, setData)
}


function copy(data) {
    navigator.clipboard.writeText(document.getElementById("emailBox").value).then(function () {
        console.log('Text successfully copied to clipboard');
    }).catch(function (err) {
        console.error('Could not copy text: ', err);
    });

    const sentBox = document.getElementById("copyBox")
    sentBox.style.display = ""
    setTimeout(() => sentBox.style.display = "none", 2000)
}

function meeting(data) {
    function generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    // Define meeting details
    var meetingDate = new Date(2024, 4, 10, 8, 0);  // Example date and time (Month is 0-indexed)
    var meetingDuration = 30;  // Meeting duration in minutes
    var meetingSubject = document.getElementById("subjectBox").value;
    var meetingAgenda = document.getElementById("emailBox").value; // Include line breaks using \n

    // Define organizer and attendee details
    var organizerEmail = 'jmaring@resource1.com'; // Organizer's email address
    var attendeeEmail = data.recepient //data.recepient; // Attendee's email address

    // Generate a UID (UUID)
    var uid = generateUUID();

    // Generate ICS content
    var icsContent =
        'BEGIN:VCALENDAR\r\n' +
        'VERSION:2.0\r\n' +
        'PRODID:-//Resource 1//NONSGML Calendar//EN\r\n' +
        'BEGIN:VEVENT\r\n' +
        'UID:' + uid + '\r\n' + // Set the UID property
        'SUMMARY:' + meetingSubject + '\r\n' +
        'DESCRIPTION:' + meetingAgenda.replace(/\n/g, '\\n') + '\r\n' + // Replace \n with \\n to escape properly
        'DTSTART:' + meetingDate.toISOString().replace(/-|:|\.\d+/g, '') + '\r\n' +
        'DTEND:' + new Date(meetingDate.getTime() + (meetingDuration * 60000)).toISOString().replace(/-|:|\.\d+/g, '') + '\r\n' +
        // 'LOCATION:' + zoomMeetingUrl + '\r\n' +
        'ORGANIZER;CN=Organizer:' + organizerEmail + '\r\n' +
        'ATTENDEE;ROLE=REQ-PARTICIPANT;PARTSTAT=NEEDS-ACTION;RSVP=TRUE;CN=Attendee:' + attendeeEmail + '\r\n' +
        'END:VEVENT\r\n' +
        'END:VCALENDAR';

    // console.log(icsContent)
    // Create a blob from the ICS content
    var blob = new Blob([icsContent], { type: 'text/calendar' });

    // Create a link element and trigger a download
    var link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = uid + '.ics';
    link.click();
}

function showQuery(data, setData) {
    const box = document.getElementById("queryBox")
    const check = document.getElementsByName("showQuery")[0]

    if (check.checked) {
        box.style.display = ""
    } else {
        box.style.display = "none"
    }
}

function EmailGenerator(args) {
    const [data, setData] = useState("success")
    const navigate = useNavigate()
    const requestManager = args.requestManager

    const queryParameters = new URLSearchParams(window.location.search)
    const contactID = queryParameters.get("EntityID")
    const companyID = queryParameters.get("CorporationID")
    const userID = queryParameters.get("UserID")

    if (typeof data.status === "undefined") {
        requestManager.request("emailGenerator", "POST", { contactID: contactID, companyID: companyID, userID: userID }).then(res => res.json()).then((response) => {
            updateQuery(response, setData)
        })
    }

    const handleQueryChange = (event) => {
        data.query = event.target.value
        setData(Object.assign({}, data))
    };

    return (
        <div class="container">
            <div class="pt-5 pb-5 mb-5 text-center">
                {
                    (typeof data.status === "undefined" || typeof data.keyError !== "undefined") ?
                        (<h1 class="loading">Loading</h1>) :
                        (<div>
                            {/* <h1 class="display-5 fw-bold pb-2">Email Generator</h1> */}
                            <div class="d-flex justify-content-evenly">
                                <span>
                                    <h1 class="display-5 ms-5">Type</h1>
                                </span>
                                <span>
                                    <h1 class="display-5">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Position</h1>
                                </span>
                            </div>
                            <div class="d-flex justify-content-center text-center">
                                <span class="switch-toggle switch-candy mb-3 col-5 mx-3">
                                    <input id="on1" onClick={() => updateType(1, data, setData)} name="view" type="radio"></input>
                                    <label for="on1" onClick={() => updateType(1, data, setData)}>Technology</label>
                                    <input id="off1" onClick={() => updateType(2, data, setData)} name="view" type="radio"></input>
                                    <label for="off1" onClick={() => updateType(2, data, setData)}>Response</label>
                                    <input id="off5" onClick={() => updateType(4, data, setData)} name="view" type="radio"></input>
                                    <label for="off5" onClick={() => updateType(4, data, setData)}>Meeting</label>
                                    <input id="off2" onClick={() => updateType(3, data, setData)} name="view" type="radio"></input>
                                    <label for="off2" onClick={() => updateType(3, data, setData)}>General</label>
                                    <a></a>
                                </span>
                                <span class="switch-toggle switch-candy mb-3 col-5 mx-3">
                                    <input id="on2" name="view2" type="radio"></input>
                                    <label for="on2" onClick={() => updatePosition(1, data, setData)}>Introductory</label>
                                    <input id="off3" name="view2" type="radio"></input>
                                    <label for="off3" onClick={() => updatePosition(2, data, setData)}>1st Followup</label>
                                    <input id="off4" name="view2" type="radio"></input>
                                    <label for="off4" onClick={() => updatePosition(3, data, setData)}>2nd Followup</label>
                                    <a></a>
                                </span>
                            </div>
                            <div id="manualSkillBox" class="row form-floating mb-2 mt-2 text-center justify-content-center">
                                <input onKeyDown={(event) => keyPressHandler(event, data, setData)} type="text" class="form-text form-control" id="floatingInput" autocomplete="off" name="Add Skill" placeholder="Add Skill"></input>
                                <label class="form-label" for="floatingInput">Add Skill Manually...</label>
                            </div>
                            <div class="col-12" id="small-table-wrapper" style={{ width: "100%" }}>
                                <table id="myTable" class="table table-bordered table-striped sortable border-2 border-dark text-center">
                                    <thead class="stickyHeader">
                                        <tr class="table-success border-2 border-dark border-top-0">
                                            <th>Technology</th>
                                            <th>Number of Resumes</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.skills.slice(0, 30).map((row) =>
                                            (selectedSkills.includes(row[0])) ?
                                                (<tr class="bg-warning" id={row[0]} onClick={() => clickHandler(row[0], data, setData)}>
                                                    <td>{row[0]}</td>
                                                    <td>{row[1]}</td>
                                                </tr>) :
                                                (<tr id={row[0]} onClick={() => clickHandler(row[0], data, setData)}>
                                                    <td>{row[0]}</td>
                                                    <td>{row[1]}</td>
                                                </tr>)
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div id="promptBox" style={{ "display": "none" }} class="form-floating mt-4 mb-2">
                                <textarea class="form-text form-control setting" id="prompt" autocomplete="off" style={{ height: "500px" }} onKeyDown={() => updateQuery(data, setData)}></textarea>
                                <label class="form-label" for="prompt">Email</label>
                            </div>
                            <div>
                                <div id="skillIndicator">
                                    <strong>Selected Skills:</strong> [{selectedSkills.toString().replaceAll(",", ",  ")}]
                                    {
                                        (selectedSkills.length != 0) ?
                                            (<div class="d-flex justify-content-center pt-2">
                                                <input type="submit" method="post" onClick={() => { selectedSkills = []; updateQuery(data, setData); }} value="Reset Selections" class="btn btn-secondary d-flex justify-content-center" style={{ width: "20%" }}></input>
                                            </div>) :
                                            (<></>)
                                    }
                                </div>
                                <div class="form-check text-center justify-content-center mt-5">
                                    <label class="text-center justify-content-center">
                                        <input class="form-check-input text-center justify-content-center border-dark" type="checkbox" name="showQuery" onClick={() => showQuery(data, setData)}></input>Manually Edit GPT Query
                                    </label>
                                </div>
                                <div id="queryBox" style={{ "display": "none" }} class="form-floating mt-1 mb-2">
                                    <textarea class="form-text form-control setting" id="query" autocomplete="off" style={{ height: "150px" }} value={data.query} onChange={handleQueryChange}></textarea>
                                    <label class="form-label" for="query">Query</label>
                                </div>
                                <div class="d-flex justify-content-center pb-2 pt-2">
                                    <input type="submit" method="post" onClick={() => getEmail(requestManager, data, setData)} value="Generate Email" class="btn btn-primary d-flex justify-content-center" style={{ width: "20%" }}></input>
                                </div>
                                <div class="d-flex justify-content-center pb-2 pt-2">
                                    <p style={{ display: "none" }} id="loadingBox">Loading, this may take up to 20 seconds...</p>
                                </div>
                                <div id="emailDiv" style={{ "display": "none" }}>
                                    <input style={{ display: "none" }} id="subjectBox" class="form-text form-control" autocomplete="off"></input>
                                    <textarea id="emailBox" class="form-text form-control" style={{ "display": "none", "height": "400px", "font-family": "Calibri", "font-size": "17px" }}></textarea>
                                    <div class="d-flex justify-content-center pb-2 pt-2">
                                        <input type="submit" method="post" onClick={() => sendEmail(requestManager, data, setData)} value="Send" class="btn btn-secondary d-flex justify-content-center mb-3 mx-3" style={{ width: "10%" }}></input>
                                        <button type="button" class="btn btn-secondary mx-3 mb-3" onClick={() => window.open("mailto:" + data.recepient + "?subject=" + data.subject + "&body=" + data.email.replaceAll("\n", "%0D%0A"))} style={{ width: "10%" }}>Open As Email</button>
                                        <button id="generateButton" class="btn btn-secondary mx-3 mb-3" onClick={() => meeting(data)}>Open As Meeting</button>
                                        {/* <button id="copy" class="btn btn-secondary mx-3 mb-3" onClick={() => copy(data)} style={{ width: "10%" }}>Copy</button> */}
                                    </div>
                                    <h1 id="sendingBox" style={{ "display": "none" }}>Sending...</h1>
                                    <h3 id="copyBox" class="text-success" style={{ "display": "none" }}>Copied!</h3>
                                    <div id="sentBox" class="text-success" style={{ "display": "none" }}>
                                        <h1>Sent!</h1>
                                        <h5>A copy of what was sent can be seen in your sent folder.</h5>
                                    </div>
                                </div>
                            </div>
                        </div>)
                }
            </div>
        </div>
    )
}

export default EmailGenerator